module.exports = __webpack_public_path__ + "static/media/f2.143fb623.jpg";